
import './style.scss'

interface LabeledDropDownProps {
	label: string
	options: string[]
	onChange: (newValue: string) => void
	value?: string
	blankValue?: string // Value to show if no value is yet set
	disabled?: boolean
	keepBlank?: boolean // flag to force the menu to remain blank after change, used to trigger multiple changes without the old value remaining
}

function LabeledDropDown({label, onChange, value, blankValue, options, disabled, keepBlank}: LabeledDropDownProps) {

	return (
		<div className='labeled-drop-down-wrap'>
			<span className='labeled-drop-down-label'>{label}</span>
			<select
				className='labeled-drop-down-select'
				onChange={(event) => {
					if (event.target.value !== '' && event.target.value !== blankValue) {
						onChange(event.target.value)
					}
					if (keepBlank) {
						event.target.value = blankValue ? blankValue : ''
					}
				}}
				value={value ? value : blankValue}
				disabled={disabled}
			>
				{!value && <option>{blankValue}</option>}
				{options.map((option, index) => 
					<option 
						value={option}
						key={`dropOption${index}`}
					>{option}</option>
				)}
			</select>
		</div>
	)
}

export default LabeledDropDown